enum ServiceAreaVersionStatusEnum {
  Created = 10,
  Activated = 20,
  Archived = 30,
}

export { ServiceAreaVersionStatusEnum };
